<template>
  <div>
    <!-- 批量填写物流单号 -->
    <el-dialog :title="$t('message.fillInTheLogisticsOrderNumberInBatch')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="580px" center>
      <div class="content">
        <div class="item" v-for="(item, index) in boxWuliuData" :key="index">
          <!-- 配送单： -->
          <div class="row">
            <div class="label fontMax">{{ $t("message.porder") }}:</div>
            <div class="val">{{ item.porder_sn }}</div>
          </div>

          <!-- 选中箱数： -->
          <div class="row">
            <div class="label">{{ $t("message.numberOfBoxesSelected") }}:</div>
            <div class="val">
              {{ item.list.length }}
            </div>
          </div>
          <!-- 选中箱号 -->
          <div class="row">
            <div class="label">{{ $t("message.selectBoxes") }}:</div>
            <div class="val">
              <span v-for="box in item.list" :key="box.number">{{ box.number }},</span>
            </div>
          </div>
        </div>
        <!-- 物流单号： -->
        <div class="row">
          <div class="label fontMax">
            {{ $t("message.logisticsSingleNumber") }}:
          </div>
          <div class="val">
            <el-input v-model="val" onfocus="this.select()" @input="noJPtext" @change="noJPtext('all')"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 批量填写物流单号 -->
        <el-button type="primary" @click="save">{{
          $t("message.confirmToFillInTheOrderNumber")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      dialogVisible: false,
      val: "",
      porder_sn: this.$route.query.porder_sn,
    };
  },
  computed: {
    ...mapState({
      boxWuliuData: (state) => state.porderDetail.boxWuliuData,
      boxIds: (state) => state.porderDetail.boxIds,
    }),
  },
  methods: {
    // 保存
    save() {
      let datas = {
        express_no: this.val.replace(/\s*/g, ""),
        freight_id_set: [],
      };

      this.boxWuliuData.forEach(item => {
        item.list.forEach(box => {
          datas.freight_id_set.push(box.id)
        })

      })
      this.$api.porderApi.updateExpressNo(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.val = "";
        this.$store.dispatch("freightList", { porder_sn: this.porder_sn });
      });
    },
    noJPtext(text) {
      const halfWidth = /[\u0000-\u00FF]/
      if (!halfWidth.test(this.val)) {
        if (text) {
          this.val = ''
        } else {
          this.val = this.val.slice(0, -1); // 删除最后一个全角字符
        }

      }
    },

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 40px;
      flex: 1;
    }

    .fontMax {
      font-size: 18px;
      font-weight: 600;
    }

    .val {
      flex: 3;
      line-height: 40px;
    }
  }
}
</style>